/**
 * Console logger, silent until `setLoggingEnabled(true)`. `App.jsx` switches it from the
 * `enable-maa-lc-console-logs` config flag.
 */

// This module is the single sanctioned place for console output, so the
// no-console rule is intentionally disabled here.
/* eslint-disable no-console */

let enabled = false;

export function setLoggingEnabled(flag) {
  enabled = !!flag;
}

export const logger = {
  log: (...args) => { if (enabled) console.log(...args); },
  warn: (...args) => { if (enabled) console.warn(...args); },
  error: (...args) => { if (enabled) console.error(...args); },
  info: (...args) => { if (enabled) console.info(...args); },
};
